import React from "react";
import "../NagthaneComponent/NagthaneCss/ WayToReach.css";
import vector from "../Images/Vector.png";
import vector1 from "../Images/Vector-1.png";
import vector2 from "../Images/Vector (2).png";
export default function WayToReach() {
  return (
    <section className="reach-section">
      <h2 className="reach-title">पोहोचण्याचा मार्ग</h2>

      <div className="reach-grid">
        {/* ✅ BUS */}
        <div className="reach-card">
          <div className="reach-icon pink-bg">
            <img src={vector} alt="" />
          </div>

          <div className="reach-content">
            <h3>बसमार्गाने</h3>
            <p> सातारा आणि कराड येथून नागठाणेपर्यंत थेट बस सेवा उपलब्ध आहे.</p>
          </div>
        </div>

        {/* ✅ TRAIN */}
        <div className="reach-card">
          <div className="reach-icon green-bg">
            <img src={vector1} alt="" />
          </div>

          <div className="reach-content">
            <h3>रेल्वेने</h3>
            <p>कराड रेल्वे स्टेशन गावापासून सुमारे १०–१२ किमी अंतरावर आहे.</p>
          </div>
        </div>

        {/* ✅ ROAD */}
        <div className="reach-card">
          <div className="reach-icon purple-bg">
            <img src={vector2} alt="" />
          </div>

          <div className="reach-content">
            <h3>रस्त्याने</h3>
            <p>कराड–सातारा मार्गावरून नागठाणे सहज जाता येते.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
